import { render } from "./JobClientRatesTable.vue?vue&type=template&id=fd1a5ff2&scoped=true&ts=true"
import script from "./JobClientRatesTable.vue?vue&type=script&lang=ts"
export * from "./JobClientRatesTable.vue?vue&type=script&lang=ts"

import "./JobClientRatesTable.vue?vue&type=style&index=0&id=fd1a5ff2&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd1a5ff2"]])

export default __exports__